import { FiCalendar } from 'react-icons/fi';

import { UiBuilding, UiExclamationTriangle } from '@vyaguta/vyaguta-icons/ui';

import CalendarCross from 'components/common/icons';
import RemoteIcon from 'components/common/remoteIcon';

import { COLORS } from 'constants/color';
import { attendanceActionMapper } from 'constants/workStatus';
import { attendanceIconMapper } from 'constants/attendanceStatus';
import { WORK_LOCATION, WORK_LOCATION_SHORT } from 'constants/worklog';

import type { AttendanceStatusMeta, MyTeamRow } from '../types';

export const getAttendanceStatusMeta = (rowData: MyTeamRow): AttendanceStatusMeta => {
  const attendanceToday = rowData?.attendance?.today || {};
  const { worklog, leave, holiday, checkInTime, isWeekend } = attendanceToday;
  const hasCheckedIn = Boolean(checkInTime);

  if (leave && !holiday) {
    return {
      Icon: CalendarCross,
      className: attendanceIconMapper.LEAVE,
      label: attendanceActionMapper.LEAVE,
      color: COLORS.purple,
      hasLogo: false,
    };
  }

  if (worklog) {
    const { location } = worklog;

    if (location === WORK_LOCATION.HOME || location === WORK_LOCATION_SHORT.HOME) {
      if (hasCheckedIn) {
        return {
          Icon: RemoteIcon,
          className: attendanceIconMapper.WIFI_CONNECTED,
          label: attendanceActionMapper.WFH_WIFI,
          color: COLORS.white,
          hasLogo: true,
        };
      }

      return {
        Icon: RemoteIcon,
        className: attendanceIconMapper.WIFI_CONNECTED,
        label: attendanceActionMapper.WFH,
        color: COLORS.white,
        hasLogo: false,
      };
    }

    if (hasCheckedIn) {
      return {
        Icon: UiBuilding,
        className: attendanceIconMapper.WIFI_CONNECTED,
        label: attendanceActionMapper.WFO_WIFI,
        color: COLORS.white,
        hasLogo: true,
      };
    }

    return {
      Icon: UiBuilding,
      className: attendanceIconMapper.WIFI_NOT_CONNECTED,
      label: attendanceActionMapper.WFO_NOWIFI,
      color: COLORS.white,
      hasLogo: true,
      logoColor: COLORS.grey20,
    };
  }

  if (isWeekend === 1) {
    return {
      Icon: FiCalendar,
      className: '',
      label: attendanceActionMapper.WEEKEND,
      color: COLORS.grey70,
      hasLogo: false,
      isWeekend: true,
    };
  }

  if (holiday?.id) {
    return {
      Icon: FiCalendar,
      className: '',
      label: holiday?.name || attendanceActionMapper.HOLIDAY,
      color: COLORS.grey70,
      hasLogo: false,
      isHoliday: true,
    };
  }

  if (hasCheckedIn && !holiday) {
    return {
      Icon: UiExclamationTriangle,
      className: attendanceIconMapper.PENDING,
      label: attendanceActionMapper.Pending_WIFI,
      color: COLORS.orange80,
      hasLogo: true,
    };
  }

  return {
    Icon: UiExclamationTriangle,
    className: attendanceIconMapper.PENDING,
    label: attendanceActionMapper.PENDING_NOWIFI,
    color: COLORS.orange80,
    hasLogo: false,
  };
};
